import './FeedStatus.scss';

const FeedStatus = ({ isMarketOpen, isLiveFeedActive }) => {
  if (!isMarketOpen) return null;

  return (
    <div
      className={`feed-status ${isLiveFeedActive ? 'feed-status--live' : 'feed-status--delayed'}`}
    >
      <span className="feed-status__dot" />
      {isLiveFeedActive ? 'Live' : '1 min delayed'}
    </div>
  );
};

export default FeedStatus;
